<template>
  <v-container id="quotreqests" fluid tag="section">
    <div class="text-right">
      <v-btn color="cyan" @click="showFilter = !showFilter" small>
        <v-icon>mdi-filter</v-icon>
      </v-btn>
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" color="light-blue" small>
            <h3>
              {{ $i18n.t("Action") }}
              <v-icon>mdi-menu-down</v-icon>
            </h3>
          </v-btn>
        </template>
        <v-list>
          <v-list-item :to="'/cargo/create'">
            <v-list-item-title>{{ $i18n.t("Create") }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>

    <!-- <v-row justify="center" v-if="showFilter">
      <v-col cols="12" md="12">
        <base-material-card
          color="light-blue"
          icon="mdi-filter"
          class="px-3 py-1 small-icon"
          v-if="showFilter"
        >
          <div class="filter-close">
            <v-btn color="black" class="mr-0" fab small text @click="showFilter = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
          <v-row>
            <v-col cols="12" md="2">
              <z-client-select v-model="filters.client_id" />
            </v-col>

            <v-col cols="12" md="2">
              <z-country-select v-model="filters.country"></z-country-select>
            </v-col>

            <v-col cols="12" md="2">
              <z-city-select v-model="filters.city" :country="filters.country"></z-city-select>
            </v-col>

            <v-col cols="12" md="2" class="text-right">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    class="mr-0"
                    color="grey darken"
                    fab
                    text
                    small
                    @click="clear(1)"
                    style="margin-right:10px !important"
                    v-on="on"
                  >
                    <v-icon>mdi-cached</v-icon>
                  </v-btn>
                </template>
                <span>{{ $i18n.t("Clear Filter") }}</span>
              </v-tooltip>
              <v-btn
                color="success"
                class="mr-0"
                fab
                small
                dark
                @click="search()"
                :loading="loading"
              >
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </base-material-card>
      </v-col>
    </v-row>-->

    <v-btn
      v-if="grid != undefined && !grid.records"
      class="text-center secondary--text pa-10"
      text
      color="primary"
      style="width:100%"
      :loading="loading"
    >{{ $i18n.t("No records available") }}</v-btn>

    <base-material-card
      icon="mdi-domain"
      :title="$i18n.t('Quotations')"
      class="px-5 py-3"
      v-if="grid.records"
    >
      <z-grid-record :grid="grid" />

      <v-card class="py-0 my-2" elevation="1" color="blue lighten-5 d-none d-md-flex">
        <v-card-text class="py-0">
          <v-row>
            <v-row>
              <v-col cols="12" md="1">{{ $i18n.t("Date") }}</v-col>
              <v-col cols="12" md="1">{{ $i18n.t("Expiry") }}</v-col>
              <v-col cols="12" md="1">{{ $i18n.t("Client") }}</v-col>
              <v-col cols="12" md="1">{{ $i18n.t("Material") }}</v-col>
              <v-col cols="12" md="1">{{ $i18n.t("Truck Type") }}</v-col>
              <v-col cols="12" md="2">{{ $i18n.t("Origin") }}</v-col>
              <v-col cols="12" md="2">{{ $i18n.t("Destination") }}</v-col>
              <v-col cols="12" md="1">{{ $i18n.t("Wish Price") }}</v-col>
              <v-col cols="12" md="2">{{ $i18n.t("Action") }}</v-col>
            </v-row>
          </v-row>
        </v-card-text>
      </v-card>

      <div v-for="quot in grid.rows" :key="quot._id" class="py-0 my-2 mt-0 mb-0" elevation="1">
        <quot-request-row :value="quot" @rejectQuot="rejectQuot" />
      </div>

      <v-container>
        <v-row justify="center">
          <v-col cols="8">
            <v-container class="max-width">
              <v-pagination
                v-model="grid.page"
                class="my-4"
                :length="grid.total"
                total-visible="10"
                @input="showPage"
              ></v-pagination>
            </v-container>
          </v-col>
        </v-row>
      </v-container>
    </base-material-card>
  </v-container>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import { doGet, doPost } from "@/store/common/module/apis";
import common from "@/store/common/module/common";
import QuotRequestRow from "@/views/quot/QuotRequestRow";

@Component({
  components: { QuotRequestRow },
})
export default class Quotations extends Vue {
  grid = { page: 0 };
  newQuotationUpdate = false;
  rows = 20;
  url = "/api/quot/grid?rows=" + this.rows;
  showFilter = false;
  name = "";
  code = "";
  filterUrl = "";
  country = "";
  city = "";
  on = null;
  page = 1;
  filters = {
    client_id: "",
    country: "",
    city: "",
  };
  bid = null;
  quot = null;

  get loading() {
    return common.loading;
  }

  @Watch("newQuotationUpdate")
  onChangeDialog(newVal) {
    if (!newVal) {
      this.quot = null;
      this.bid = null;
    }
  }

  async mounted() {
    common.setLoading(true);
    try {
      this.grid = await doGet(this.url);
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }

  async showPage(page) {
    this.page = page;
    this.grid = await doGet(this.url + this.filterUrl + "&page=" + page);
    common.setLoading(false);
  }

  async clear() {
    this.filters = {};
    this.page = 1;
    this.search();
  }

  async search() {
    this.filterUrl = "";
    if (this.filters.client_id)
      this.filterUrl += "&name=" + this.filters.client_id;
    if (this.filters.country)
      this.filterUrl += "&address.country=" + this.filters.country;
    if (this.filters.city)
      this.filterUrl += "&address.city=" + this.filters.city;
    common.setLoading(true);
    await this.showPage(1);
  }

  async rejectQuot(quot) {
    common.setLoading(true);
    try {
      await doGet("api/bid/quot/" + quot._id + "/cancel");
      common.showMessage("Cancelled Successfully");
      await this.search();
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }
}
</script>

<style scoped>
.filter-close {
  position: absolute;
  right: 5px;
  top: 5px;
}
.dialog {
  position: fixed;
  top: 100px;
  width: 60%;
  z-index: 10;
  margin-left: 15%;
}
.btn-list-item {
  padding: 0;
  float: left !important;
}
.btn-list-item .v-btn--text {
  padding: 0;
  text-transform: none;
  font-size: 14px;
  float: left;
  margin: 0;
}
</style>
